const styles = {
  group: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 1,
  },
  container: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    gap: 1,
  },
}

export default styles
